export function isRegionPopulate(region, key) {
    var _a, _b;
    console.log('regions', region === null || region === void 0 ? void 0 : region.regions);
    return !!((_b = (_a = region === null || region === void 0 ? void 0 : region.regions[key]) === null || _a === void 0 ? void 0 : _a.components) === null || _b === void 0 ? void 0 : _b.length);
}
export function extractNativeComponent(page, id) {
    var _a;
    let _component;
    if ((_a = page === null || page === void 0 ? void 0 : page.regions) === null || _a === void 0 ? void 0 : _a.length) {
        page.regions.forEach((region) => {
            var _a;
            if ((_a = region === null || region === void 0 ? void 0 : region.components) === null || _a === void 0 ? void 0 : _a.length) {
                region.components.forEach((component) => {
                    if (component.id === id) {
                        _component = component;
                    }
                });
            }
        });
    }
    return _component;
}
export function extractNativeRegionComponents(component, id) {
    var _a;
    let _components;
    if ((_a = component === null || component === void 0 ? void 0 : component.regions) === null || _a === void 0 ? void 0 : _a.length) {
        component.regions.forEach((region) => {
            var _a;
            if (region.id === id && ((_a = region === null || region === void 0 ? void 0 : region.components) === null || _a === void 0 ? void 0 : _a.length)) {
                _components = region.components;
            }
        });
    }
    return _components;
}
// const isRegionsPopulate = (region: Region, key: string) => {
//   return !!region.regions[key]
// };
